module.exports = __webpack_public_path__ + "img/paypal.f5ee8d1e.png";